import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, AlertTriangle } from "lucide-react";
import MarketingHeader from "../components/argus/MarketingHeader";
import Footer from "../components/argus/Footer";
import { Button } from "../components/ui/button";
import { api } from "../lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState(token ? "loading" : "missing");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) return;
    api
      .get(`/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(() => setState("verified"))
      .catch((e) => {
        setError(e?.response?.data?.detail || "That link is invalid.");
        setState("error");
      });
  }, [token]);

  return (
    <div className="bg-paper text-ink min-h-screen flex flex-col">
      <MarketingHeader />
      <section className="flex-1 mx-auto max-w-xl w-full px-4 py-20 text-center">
        {state === "loading" && (
          <div data-testid="verify-loading">
            <Loader2 size={40} className="mx-auto animate-spin text-gold mb-4" />
            <h1 className="font-display text-3xl">Verifying your email…</h1>
          </div>
        )}
        {state === "verified" && (
          <div data-testid="verify-success">
            <CheckCircle2 size={48} className="mx-auto text-safe mb-4" />
            <h1 className="font-display text-4xl mb-2">Email verified.</h1>
            <p className="text-ink/70 mb-8">Your ArgusSecure account is active. Head into the app.</p>
            <Link to="/app">
              <Button className="bg-gold text-paper hover:bg-gold2 h-12 px-6 font-semibold">
                Go to Dashboard
              </Button>
            </Link>
          </div>
        )}
        {state === "error" && (
          <div data-testid="verify-error">
            <AlertTriangle size={48} className="mx-auto text-sev-high mb-4" />
            <h1 className="font-display text-3xl mb-2">That link won't work.</h1>
            <p className="text-ink/70 mb-6">{error}</p>
            <Link to="/login">
              <Button className="bg-gold text-paper hover:bg-gold2 h-12 px-6 font-semibold">
                Go to login
              </Button>
            </Link>
          </div>
        )}
        {state === "missing" && (
          <div data-testid="verify-missing">
            <h1 className="font-display text-3xl mb-2">Missing token.</h1>
            <p className="text-ink/70">Open the verification link from your email inbox.</p>
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
